export const Errors = {
    Message: {
        SERVER_ERROR: "Internal Server Error",
    },
    StatusCode: {
        SERVER_ERROR: 500,
    }
};
